import React, { useState, useEffect } from "react"
import Img from "gatsby-image"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import "./benefits-product.scss"

const BenefitsProduct = ({ params, mobile }) => {
  return (
    <section className="f-benefits-section-product">
      <div className="f-benefits-content">
        <TitleTab
          className={"f-TitleTab f-TitleTab-pink"}
          title={
            mobile ? "¡Sus beneficios!" : "¡Sus beneficios son increíbles!"
          }
        />

        <div className="f-section-container">
          <div className="f-left-section">
            <div className="f-description-container">
              {documentToReactComponents(params.beneficios.json)}
            </div>
          </div>
          <div className="f-right-section">
            {params.beneficiosImagen && (
              <div className="f-benefits-img">
                <Img
                  fluid={params.beneficiosImagen.fluid}
                  objectFit="contain"
                  alt={params.beneficiosImagen.description}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BenefitsProduct
